<base-support-modal [title]="title" [btnOkClass]="'btn-danger'" [btnOkLabel]="'Удалить'" (onOk)="ok()" >
	<p>Причины удаления сайта:</p>
	<textarea [(ngModel)]="message" class="form-control" rows="3"></textarea>
	<br>
	<p>Пользователь получит письмо на email: <strong>{{userEmail}}</strong></p>
</base-support-modal>
